const _utils = {
  OnElementLoad (selector, callback) {
    let count = 0
    var t = setInterval(function() {
      var element = document.querySelector(selector);
      count += 100;
      if (
        (element !== null && element !== undefined) || 
        count > 100 * 10 * 3
      ) {
        clearInterval(t);
        callback(element);
      }
    }, 100);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductFormIron', () => ({
      flags: {
        custom_options: false
      },
      preselects: [
        {selector: '.pplr-loft', name: 'Loft', value: 'Standard', type: 'select', show: true},
        {selector: '.pplr-lie-angle', name: 'Lie Angle', value: 'Standard', type: 'select', show: true},
        {selector: '.pplr-length', name: 'Length', value: 'Standard', type: 'select', show: true},
        {selector: '.pplr-shaft-x-8', name: 'Shaft X 8', value: 'KBS Tour Lite - R 95g', type: 'select', show: true},
      ],
      init() {
        let handle = this.$el.dataset.handle;
        if (handle == 'sms-sms-pro-irons-combo') {
          this.preselects = [...this.preselects, ...[
            {selector: '.pplr-shaft-x-7', name: 'Shaft X 7', value: 'KBS Tour Lite - R 95g', type: 'select', show: false},
            {selector: '.pplr-grip-x-7', name: 'Grip x 7', value: 'Golf Pride Tour Velvet - Standard', type: 'select', show: false},    
          ]];
        }
        else {
          this.preselects = [...this.preselects, ...[
            {selector: '.pplr-grip-x-8', name: 'Grip x 8', value: 'Golf Pride Tour Velvet - Standard', type: 'select', show: true},
            {selector: '.pplr-edel-x-bbf-ferrule', name: 'Edel X BB&F Ferrule', value: 'Red & Black', type: 'input', show: true},
          ]];
        }
        this.InitWatchers();
      },
      InitWatchers() {
        let $personalizer;
        _utils.OnElementLoad('.product-personalizer .pplr-dropdown', ($element) => {
          $personalizer = $element.closest('.product-personalizer');
          this.UpdatePersonalizer($personalizer);
        });

        this.$watch('flags.custom_options', () => {
          this.UpdatePersonalizer($personalizer);
        });
      },
      UpdatePersonalizer($personalizer) {
        // console.log($personalizer);
        if (this.flags.custom_options) return;

        // Load preselects if Standard Selected
        let preselects = [
          {selector: '.pplr-loft', value: 'Standard', type: 'select'},
          {selector: '.pplr-lie-angle', value: 'Standard', type: 'select'},
          {selector: '.pplr-length', value: 'Standard', type: 'select'},
          {selector: '.pplr-shaft-x-8', value: 'KBS Tour Lite - R 95g', type: 'select'},
          {selector: '.pplr-grip-x-8', value: 'Golf Pride Tour Velvet - Standard', type: 'select'},
          {selector: '.pplr-edel-x-bbf-ferrule', value: 'Red & Black', type: 'input'},

          {selector: '.pplr-shaft-x-7', value: 'KBS Tour Lite - R 95g', type: 'select'},
          {selector: '.pplr-grip-x-7', value: 'Golf Pride Tour Velvet - Standard', type: 'select'},
        ];

        preselects.forEach(item => {
          let $input = $personalizer.querySelector(`${item.selector} select`) ||
            $personalizer.querySelector(`${item.selector} input`);
          if ($input) {
            if (item.type == 'select') {
              var preselect_value = $input.querySelector('option:nth-of-type(2)').value;
              if ($input.querySelector(`option[value="${item.value}"]`)) {
                preselect_value = item.value;
              }  
            }

            if (item.type == 'input') {
              preselect_value = item.value;
              let $container = $personalizer.querySelector(item.selector);
              let $swatch = $container.querySelector(`[data-val="${preselect_value}"]`);
              if ($swatch) {
                $swatch.dispatchEvent(new Event('click', {bubbles: true}));
              }
            }
            $input.value = preselect_value;
            $input.dispatchEvent(new Event('change', {bubbles: true}));
          }
        });
      }
    }));
  });
})();
